import React from 'react';
import { MBView } from '@shared/components/MBView';
import { SharedStyles } from '@shared/styles';
import { FileDropListenerOverlay } from './overlay';
import { MBFileDropListenerProps } from './props';
import { UnvalidatedStyles } from './styles';

interface State {
  isFileHoovering: boolean;
}

/*
    This component listens to files being dragged over it. When a file is dragged over,
    we show an overlay. When the file is dropped we call this.props.onDrop to let the
    parent handle the file.

    Note: this has some hacky logic connected to this.dragEnterEventCount. For some
    reason, the form component behaves like this:

    onDragEnter
    onDragEnter
    onDragLeave

    when a file is dragged over it. This causes the isFileHoovering to flicked back and forth.
    Maybe because the state is being updated connected to the change? Anyway, we keep the
    counter to just change the hoover state when the file is actually not over the component
    anymore.
*/
export class MBFileDropListener extends React.PureComponent<MBFileDropListenerProps, State> {
  dragEnterEventCount: number = 0;
  state: State = { isFileHoovering: false };

  handleFileDragOver = (event: React.DragEvent<HTMLFormElement>) => event.preventDefault();
  handleSubmit = (event: React.DragEvent<HTMLFormElement>) => event.preventDefault();

  handleFileDragEnter = (event: React.DragEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!this.state.isFileHoovering) {
      this.dragEnterEventCount = 0;
      this.setState({ isFileHoovering: true });
    }

    this.dragEnterEventCount += 1;
  };

  handleFileDragLeave = (event: React.DragEvent<HTMLFormElement>) => {
    event.preventDefault();

    this.dragEnterEventCount -= 1;
    if (this.dragEnterEventCount === 0) {
      this.setState({ isFileHoovering: false });
    }
  };

  handleFileDrop = (event: React.DragEvent<HTMLFormElement>) => {
    event.preventDefault();
    this.setState({ isFileHoovering: false });

    const files = event.dataTransfer.files;
    if (files.length) {
      // files is of type FileList, which is a list but doesn't have
      // array functions (eg map). We convert it to an array to make
      // it more easily used
      this.props.onFilesDropped(Array.from(files));
    }
  };

  static defaultProps = {
    overlay: <FileDropListenerOverlay />,
  };

  render() {
    const { overlay, ...restProps } = this.props;

    if (this.props.disabled) {
      return <MBView {...restProps} />;
    }

    return (
      // oxlint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <form
        style={UnvalidatedStyles.form as any}
        onDragEnter={this.handleFileDragEnter}
        onDragLeave={this.handleFileDragLeave}
        onDragOver={this.handleFileDragOver}
        onDrop={this.handleFileDrop}
        onSubmit={this.handleSubmit}
      >
        <MBView {...restProps} />
        {this.state.isFileHoovering && (
          <MBView style={SharedStyles.absoluteCover}>{overlay}</MBView>
        )}
      </form>
    );
  }
}
